// UI monolíngue por ora: o texto vem do bundle pt-BR direto, não do i18next
// (ver i18n/README.md — trocar o idioma padrão é trocar este caminho).
import signup from '@/i18n/locales/pt-BR/signup.json';

export type CountryOption = {
  code: string;
  label: string;
};

export const DEFAULT_NATIONALITY = 'BR';

export const COUNTRIES: CountryOption[] = [
  { code: 'BR', label: signup.countries.BR },
  { code: 'AR', label: signup.countries.AR },
  { code: 'BO', label: signup.countries.BO },
  { code: 'CL', label: signup.countries.CL },
  { code: 'CO', label: signup.countries.CO },
  { code: 'US', label: signup.countries.US },
  { code: 'ES', label: signup.countries.ES },
  { code: 'FR', label: signup.countries.FR },
  { code: 'DE', label: signup.countries.DE },
  { code: 'PT', label: signup.countries.PT },
  { code: 'PY', label: signup.countries.PY },
  { code: 'UY', label: signup.countries.UY },
];

export function getCountryLabel(code: string): string {
  const key = code as keyof typeof signup.countries;
  return signup.countries[key] ?? code;
}
